// Página dev de QA permanente para verificar conectividad con Supabase.
// Al montar dispara SELECT * FROM ejercicios y muestra el resultado.

import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase/client";

type Status =
  | { kind: "loading" }
  | { kind: "error"; message: string }
  | { kind: "ok"; rows: unknown[] };

export function DevDbTest() {
  const [status, setStatus] = useState<Status>({ kind: "loading" });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase.from("ejercicios").select("*");
      if (cancelled) return;
      if (error) {
        setStatus({ kind: "error", message: error.message });
      } else {
        setStatus({ kind: "ok", rows: data ?? [] });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-neutral-950 p-6 text-neutral-100 font-mono">
      <h1 className="text-xl mb-2">Dev DB Test — Supabase ejercicios</h1>
      <p className="mb-3 text-xs opacity-70">
        SELECT * FROM ejercicios. Página provisoria de QA de conectividad.
      </p>
      {status.kind === "loading" && (
        <p className="text-emerald-400">Cargando…</p>
      )}
      {status.kind === "error" && (
        <pre className="text-red-400 whitespace-pre-wrap break-all">
          Error: {status.message}
        </pre>
      )}
      {status.kind === "ok" && (
        <>
          <p className="mb-2 text-emerald-400">{status.rows.length} fila(s)</p>
          <pre className="text-xs whitespace-pre-wrap break-all bg-neutral-900 p-3 rounded border border-neutral-800">
            {JSON.stringify(status.rows, null, 2)}
          </pre>
        </>
      )}
    </div>
  );
}
